import moment from 'moment';
import { Moment, Duration } from 'moment';
import { useCallback } from 'react';
import { ALASKA_TIME_ZONE, getDateMoment } from 'src/utils/dateUtils';
import { HosGridObject } from '../hosLog/types';
import { HosLogObject } from '../types';

export const useOriginEvent = (
  date: string,
  eventLogObject: HosLogObject,
  index: number,
): [Moment | undefined, Moment | undefined, HosGridObject | undefined] => {
  if (index < 0) return [undefined, undefined, undefined];
  const event = eventLogObject.hosGridObject[index];
  const start = event.timeISO
    ? moment.tz(event.timeISO, eventLogObject.timeZone)
    : getDateMoment(`${date} ${event.time}`);
  const end = event.timeISO
    ? moment.tz(event.timeISO, eventLogObject.timeZone).add(event.duration, 'seconds')
    : getDateMoment(`${date} ${event.time}`, (event.duration as Duration).asSeconds(), 'seconds');

  return [start, end, event];
};

export const useGetDateTimezoneMoment = (
  date: string,
  zone: string,
): {
  (time: string, duration?: moment.DurationInputArg1, unit?: moment.DurationInputArg2): Moment;
} => {
  return useCallback(
    (time, duration, unit) =>
      getDateMoment(
        `${date} ${time} ${zone === ALASKA_TIME_ZONE ? '-09:00' : zone}`,
        duration,
        unit,
      ),
    [date, zone],
  );
};

export const useGetPeriodNormlizer = () =>
  useCallback((startDate: Date, endDate: Date) => {
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    return [startMoment, endMoment];
  }, []);
